export enum MOCK_TEST_STATUS {
  ATTEMPTED = 'ATTEMPTED',
  NOT_YET_TAKEN = 'NOT_YET_TAKEN',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum MOCK_TEST_USER_STATUS {
  DONE = 'DONE',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum MOCK_TEST_TYPE {
  FULL_TEST = 'FULL_TEST',
  SECTION_TEST = 'SECTION_TEST',
  QUESTION_TEST = 'QUESTION_TEST',
}
